"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _keyDownHandler = _interopRequireDefault(require("../../handlers/keyDownHandler"));
var _excluded = ["colorTheme", "label", "textOn", "textOff", "className", "style", "tabIndex"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Toggle = /*#__PURE__*/function (_Component) {
  function Toggle(props) {
    var _this;
    _classCallCheck(this, Toggle);
    _this = _callSuper(this, Toggle, [props]);
    _this.state = {
      isSetup: false,
      maxWidth: 0,
      checked: props.checked
    };
    return _this;
  }
  _inherits(Toggle, _Component);
  return _createClass(Toggle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resetToggleSize();
      this.setState({
        isSetup: true
      });
    }

    // Based on the textOff and textOn, set the width of the toggle
  }, {
    key: "resetToggleSize",
    value: function resetToggleSize() {
      var width = 0;
      if (this.elTextOn !== undefined) {
        width = this.elTextOn.offsetWidth;
      }
      if (this.elTextOff !== undefined && this.elTextOff.offsetWidth > width) {
        width = this.elTextOff.offsetWidth;
      }
      if (width === 0 && this.props.textOn && this.props.textOff) {
        width = (this.props.textOn.length > this.props.textOff.length ? this.props.textOn.length : this.props.textOff.length) * 6;
      }
      if (width > this.elToggle.offsetWidth - 24) {
        width = width / 16 + 4;
      } else {
        width = this.elToggle.offsetWidth / 16;
      }
      this.setState({
        isSetup: true,
        maxWidth: width
      });
    }
  }, {
    key: "keyDown",
    value: function keyDown(event) {
      var key = _keyDownHandler["default"].getKeysFromEvent(event);
      if (key === _keyDownHandler["default"].keys.spacebar) {
        this.changeEvent(event);
      }
    }
  }, {
    key: "click",
    value: function click(event) {
      this.changeEvent(event);
    }
  }, {
    key: "changeEvent",
    value: function changeEvent(event) {
      var _this2 = this;
      event.preventDefault();
      if (!this.props.disabled) {
        if (this.props.checked !== undefined) {
          this.setState({
            checked: !this.state.checked
          }, function () {
            _this2.props.onChange({
              target: {
                value: _this2.props.value,
                checked: _this2.state.checked
              }
            });
          });
        } else {
          this.props.onChange({
            target: {
              value: this.props.value,
              checked: !this.props.checked
            }
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        colorTheme = _this$props.colorTheme,
        label = _this$props.label,
        textOn = _this$props.textOn,
        textOff = _this$props.textOff,
        className = _this$props.className,
        style = _this$props.style,
        tabIndex = _this$props.tabIndex,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var currentChecked = this.props.checked !== undefined ? this.props.checked : this.state.checked;

      // To calculate the width of the longer text we must have both visible
      var initialisationClass = (0, _classnames["default"])({
        "text-init-state": !this.state.isSetup
      });
      var toggleClass = (0, _classnames["default"])("toggle", {
        "disabled": this.props.disabled,
        "checked": currentChecked
      }, colorTheme, className);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "toggle-component",
        id: this.props.id,
        tabIndex: tabIndex,
        onKeyDown: function onKeyDown(e) {
          return _this3.keyDown(e);
        },
        onClick: function onClick(e) {
          return _this3.click(e);
        }
      }, label !== null && /*#__PURE__*/_react["default"].createElement("label", null, label), /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, rest, {
        checked: currentChecked,
        disabled: this.props.disabled,
        name: this.props.name
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: toggleClass,
        ref: function ref(el) {
          return _this3.elToggle = el;
        },
        style: {
          width: this.state.maxWidth + 'rem'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "pill",
        style: _objectSpread({
          transform: "translate(".concat(currentChecked ? this.state.maxWidth - 2.875 : 0, "rem, 0)")
        }, style)
      }), textOn !== null && /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          width: this.state.maxWidth != 0 ? "calc(".concat(this.state.maxWidth, "rem - 1.8125rem - 0.5rem") : 'auto'
        },
        className: "text text-on ".concat(initialisationClass),
        ref: function ref(el) {
          return _this3.elTextOn = el;
        }
      }, textOn), textOff !== null && /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          width: this.state.maxWidth != 0 ? "calc(".concat(this.state.maxWidth, "rem - 1.8125rem - 0.5rem") : 'auto'
        },
        className: "text text-off ".concat(initialisationClass),
        ref: function ref(el) {
          return _this3.elTextOff = el;
        }
      }, textOff)));
    }
  }]);
}(_react.Component);
Toggle.propTypes = {
  colorTheme: _propTypes["default"].oneOf(["teal", "grey", "white", 'red', "purple"]),
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  value: _propTypes["default"].string,
  textOn: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  textOff: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  onChange: _propTypes["default"].func,
  checked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  tabIndex: _propTypes["default"].number,
  id: _propTypes["default"].string,
  name: _propTypes["default"].string
};
Toggle.defaultProps = {
  colorTheme: "teal",
  label: null,
  name: "",
  value: "",
  textOn: null,
  textOff: null,
  onChange: function onChange() {},
  checked: false,
  disabled: false,
  className: "",
  style: {},
  tabIndex: 1,
  id: null
};
var _default = exports["default"] = Toggle;